module.exports = __webpack_public_path__ + "assets/a-3-chuangkoutie.94634844.svg";